import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/v-home'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'v-home',
    component: Home
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js